import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import NumberService from "../../../Services/Shared/Number.service";
import ListService from "../../../Services/Shared/List.service";
export const DefaultShowMoreListButton = ({ numItemsShown, numItemsHidden, showHideToggle, numOfItemsToPreview, className, }) => {
    if (numItemsHidden === 0 && numItemsShown <= numOfItemsToPreview) {
        return null;
    }
    const buttonText = numItemsHidden > 0
        ? `${NumberService.format(numItemsHidden)} More`
        : "Show less";
    return (_jsx("div", { children: _jsx("button", { className: classNames("btn btn-link underline py-0", className), type: "button", onClick: () => showHideToggle(), children: buttonText }) }));
};
/**
 * Sensible default for displaying items that are nodes
 */
export const DefaultShowMoreListRenderer = ({ items, numItemsHidden, showHideToggle, numOfItemsToPreview, }) => {
    return (_jsxs("div", { className: "d-flex flex-wrap", children: [items.map((item, index) => (_jsx("span", { className: "mr-1 mb-2", children: item }, index))), _jsx("span", { className: "mr-1 mb-2 d-flex align-items-center", children: _jsx(DefaultShowMoreListButton, { numItemsHidden: numItemsHidden, showHideToggle: showHideToggle, numItemsShown: items.length, numOfItemsToPreview: numOfItemsToPreview }) })] }));
};
/**
 * Shows a list of strings as comma separated.
 */
export const StringShowMoreListRenderer = ({ items, numItemsHidden, showHideToggle, numOfItemsToPreview, }) => {
    const showingAll = numItemsHidden === 0;
    return (_jsxs("div", { children: [showingAll
                ? ListService.displayWithCommasAndAnd(items)
                : items.join(", "), _jsx("span", { children: _jsx(DefaultShowMoreListButton, { className: "align-baseline", showHideToggle: showHideToggle, numItemsHidden: numItemsHidden, numItemsShown: items.length, numOfItemsToPreview: numOfItemsToPreview }) })] }));
};
/**
 *  Shows a list of nodes vertically aligned.
 */
export const VerticalShowMoreListRenderer = ({ items, numItemsHidden, showHideToggle, numOfItemsToPreview, }) => {
    return (_jsxs("div", { children: [items.map((item, index) => (_jsx("div", { children: item }, index))), _jsx(DefaultShowMoreListButton, { numItemsHidden: numItemsHidden, showHideToggle: showHideToggle, numItemsShown: items.length, numOfItemsToPreview: numOfItemsToPreview, className: "px-0" })] }));
};
const ShowMoreList = ({ items, numOfItemsToPreview, renderer: Renderer = DefaultShowMoreListRenderer, showWhenEmptyList = null, }) => {
    const [showAllItems, setShowAllItems] = React.useState(false);
    const numItemsHidden = showAllItems
        ? 0
        : Math.max(0, items.length - numOfItemsToPreview);
    const itemsShown = showAllItems ? items : items.slice(0, numOfItemsToPreview);
    if (items.length === 0) {
        // @ts-expect-error problem with react types.  Remove when upgrading to react 18.
        return showWhenEmptyList;
    }
    return (_jsx(Renderer, { numItemsHidden: numItemsHidden, items: itemsShown, showHideToggle: () => setShowAllItems((s) => !s), numOfItemsToPreview: numOfItemsToPreview }));
};
export default ShowMoreList;
